import { jsx as n } from "react/jsx-runtime";
const s = ({
  size: o = 16,
  color: r = "currentColor",
  strokeWidth: t = 1.5,
  ...e
}) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 20 20",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ n(
      "path",
      {
        d: "M10 13.25V10M10 6.75H10.0081M18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10C1.875 5.51269 5.51269 1.875 10 1.875C14.4873 1.875 18.125 5.51269 18.125 10Z",
        stroke: r,
        strokeWidth: t,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
export {
  s as InfoIcon
};
